'use client';

import { WebsiteAuth } from '@/features/auth/WebsiteAuth';
import { ShopifyIframeAuth } from '@/features/auth/ShopifyIframeAuth';
import { CommonProviders } from '@/providers/helper/CommonProviders';
import { PageLayoutComponent } from '@/features/auth/PageLayoutComponent';
import { AuthenticatedLayout } from '@/features/auth/AuthenticatedLayout';
import { NotAuthenticatedLayout } from '@/features/auth/NotAuthenticatedLayout';
import PageComponents from './PageComponents';
import { useUserDataStore } from '@/stores/userDataStore';

const ShopifyLayoutComponent = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn } = useUserDataStore();
  const Layout: PageLayoutComponent = isLoggedIn ? AuthenticatedLayout : NotAuthenticatedLayout;
  return (
    <Layout isShopifyIframe={true}>
      {children}
      <PageComponents />
    </Layout>
  );
};

const LayoutComponent = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn } = useUserDataStore();
  const Layout: PageLayoutComponent = isLoggedIn ? AuthenticatedLayout : NotAuthenticatedLayout;
  return <Layout>{children}</Layout>;
};

const AuthCheck = ({
  children,
  isShopifyIframe,
  serverPath,
  host,
}: {
  children: React.ReactNode;
  isShopifyIframe: boolean;
  serverPath?: string;
  host: string;
}) => {
  if (isShopifyIframe) {
    return (
      <ShopifyIframeAuth serverPath={serverPath} host={host}>
        <CommonProviders>
          <ShopifyLayoutComponent>{children}</ShopifyLayoutComponent>
        </CommonProviders>
      </ShopifyIframeAuth>
    );
  }

  return (
    <WebsiteAuth>
      <CommonProviders>
        <LayoutComponent>{children}</LayoutComponent>
      </CommonProviders>
    </WebsiteAuth>
  );
};

export default AuthCheck;
